import React, { useEffect } from "react";
import "./AccountPage.css";
import { useStateValue } from "../../StateProvider";
import { Link, useNavigate } from "react-router-dom";
import { account } from "../../appwrite";
import { useTitle } from "../../hooks/useTitle";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import {
  Truck,
  LockKeyhole,
  CircleHelp,
  ScrollText,
  Banknote,
  ShieldCheck,
  ChevronRight,
  LogOut,
} from "lucide-react";

const Account = () => {
  useTitle("My Account - TrendBay");
  const [{ user }, dispatch] = useStateValue();
  const navigate = useNavigate();

  useEffect(() => {
    account.get().catch(() => navigate("/login"));
  }, [navigate]);

  const handleSignOut = async () => {
    try {
      await account.deleteSession("current");
      dispatch({ type: "SET_USER", user: null });
    } catch {}
    navigate("/login");
  };

  const name = user ? (user.name || user.displayName || "User") : "User";
  const email = user?.email || "";
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase() || "U";

  return (
    <div className="acc-page">
      <Navbar />
      <div className="acc-wrap">

        <div className="acc-profile">
          <div className="acc-avatar">{initials}</div>
          <div>
            <h2 className="acc-name">{name}</h2>
            <p className="acc-email">{email}</p>
          </div>
        </div>

        <section className="acc-section">
          <h3 className="acc-section-label">Account</h3>
          <div className="acc-card">
            <Link to="/orders" className="acc-row">
              <div className="acc-row-left">
                <Truck size={18} />
                <span>My Orders</span>
              </div>
              <ChevronRight size={18} className="acc-chevron" />
            </Link>
            <Link to="/account/change-password" className="acc-row">
              <div className="acc-row-left">
                <LockKeyhole size={18} />
                <span>Change Password</span>
              </div>
              <ChevronRight size={18} className="acc-chevron" />
            </Link>
          </div>
        </section>

        <section className="acc-section">
          <h3 className="acc-section-label">About</h3>
          <div className="acc-card">
            <Link to="/frequently-asked-questions" className="acc-row">
              <div className="acc-row-left">
                <CircleHelp size={18} />
                <span>F.A.Q</span>
              </div>
              <ChevronRight size={18} className="acc-chevron" />
            </Link>
            <Link to="/terms-and-conditions" className="acc-row">
              <div className="acc-row-left">
                <ScrollText size={18} />
                <span>Terms &amp; Conditions</span>
              </div>
              <ChevronRight size={18} className="acc-chevron" />
            </Link>
            <Link to="/refund-policy" className="acc-row">
              <div className="acc-row-left">
                <Banknote size={18} />
                <span>Refund Policy</span>
              </div>
              <ChevronRight size={18} className="acc-chevron" />
            </Link>
            <Link to="/privacy-policy" className="acc-row">
              <div className="acc-row-left">
                <ShieldCheck size={18} />
                <span>Privacy Policy</span>
              </div>
              <ChevronRight size={18} className="acc-chevron" />
            </Link>
          </div>
        </section>

        <button className="acc-signout" onClick={handleSignOut}>
          <LogOut size={17} />
          Sign Out
        </button>

      </div>
      <Footer />
    </div>
  );
};

export default Account;
